<template>
  <SingleNews />
</template>

<script>
import SingleNews from '@/components/content/news/SelectedNews.vue'

export default {
  name: 'SingleNewsPage',
  components: { SingleNews }
}
</script>

<style scoped>

</style>
